/**
 * MouseWheel (für allen spiele geeignet)
 * aus: http://gamedev.rasmuswriedtlarsen.com/2010/01/18/quicktip-scrolling-only-in-swf-not-on-page/
 *
 * wenn die maus über das swf bewegt wird, dann scrollt der browser nicht mehr
 * somit wirkt das scrollen nur im swf, ausserhalb scrollt die html-seite.
 * !!! könnte bei CS5 anders sein?
 *
 * @author "hgs"
 * Last changes: 12.04.2010
 */

import { error } from "../logging/error";

import Stage = createjs.Stage;
import Event = createjs.Event;
import MouseEvent = createjs.MouseEvent;
//import {ExternalInterface} from "@goodgamestudios/createjs-utilities";

export class MouseWheel {
    private _stage: Stage;

    // indiziert javascript
    private MWJS: string = "" + "let browserScrolling=true;" + "function allowBrowserScroll(value){browserScrolling=value;}" + "function handle(delta){return browserScrolling;}" + "function wheel(evt){" + "	let delta=0;" + "	if(!evt){evt=window.event;}" + "	if(evt.wheelDelta){" + "		delta=evt.wheelDelta/120;" + "		if(window.opera){delta=-delta;}" + "	}else if(evt.detail){" + "		delta=-evt.detail/3;" + "	}" + "	if(delta){handle(delta);}" + "	if(!browserScrolling){" + "		if(evt.preventDefault){evt.preventDefault();}" + "		evt.returnValue=false;" + "}	}" + "if(window.addEventListener){window.addEventListener('DOMMouseScroll',wheel,false);}" + "window.onmousewheel=document.onmousewheel=wheel;";

    constructor(s: Stage, enableMouseWheel: boolean = true) {
        if (enableMouseWheel) {
            this._stage = s;
            // TODO: @HTML5
            /*try {
                if (ExternalInterface.available) {
                    ExternalInterface.call("eval", this.MWJS);
                    this._stage.addEventListener("mousemove", this.bindFunction(this.eventMouseWheelFlash));
                }
            }
            catch (e) {
                error("ExternalInterface not available " + this.e.getStackTrace());
            }*/
        }
    }

    // call self: wird eigentlich nie benötigt
    public destructor(): void {
        this._stage.removeEventListener("mouseleave", this.bindFunction(this.eventMouseWheelBrowser));
        this._stage.removeEventListener("mousemove", this.bindFunction(this.eventMouseWheelFlash));
    }

    // false= browser scrollt nicht, somit scrollt das swf
    private eventMouseWheelFlash(evt: MouseEvent): void {
        this._stage.removeEventListener("mousemove", this.bindFunction(this.eventMouseWheelFlash));
        this._stage.addEventListener("mouseleave", this.bindFunction(this.eventMouseWheelBrowser));
        this.allowBrowserScroll(false);
    }

    // true=  browser scrollt
    private eventMouseWheelBrowser(evt: Event): void {
        this._stage.addEventListener("mousemove", this.bindFunction(this.eventMouseWheelFlash));
        this._stage.removeEventListener("mouseleave", this.bindFunction(this.eventMouseWheelBrowser));
        this.allowBrowserScroll(true);
    }

    private allowBrowserScroll(allow: boolean): void {
        // TODO: @HTML5
        /*try {
            if (ExternalInterface.available) {
                ExternalInterface.call("allowBrowserScroll", allow);
            }
        }
        catch (e: Error) {
            error("ExternalInterface not available " + this.e.getStackTrace())
        }*/
    }

    //
    // ende
    //
}
